
import { defineComponent, ref } from "vue";

export default defineComponent({
    name: "QuestionnaireGeneralError",
    props: {
        message: { type: String },
    },
    setup(props) {
        const messageRef = ref(props.message);

        if (props.message) {
            sessionStorage["QuestionnaireErrorMessage"] = messageRef.value;
        } else {
            messageRef.value = sessionStorage["QuestionnaireErrorMessage"];
        }

        return {
            messageRef,
        };
    }
});
